/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Price } from './price';

/**
 * Special insurance for trucks concerning brake/operation/breakage damages.   (german: Brems-, Betriebs- und Bruchschäden)
 */
export interface BBB {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
}
